import React, { Component ,useState ,useEffect} from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from "sweetalert2";
import axios from "axios";
import { currentDateAndTime, decodeData } from '../../Constants/constants';
import { otTypes } from '../../Constants/constants';
import { formatDate, IconButton, SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from '../../Components/Shimmer';

class LevelDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);

    // Initial state to store form data and validation errors
    this.state = {
      selectedSalaryType: null,
      company_salary_statutory_id: null,
      employee_salary_statutory_id: null,
      salaryRows: [],
      allowances: [],
      salary_statutory: [],
      statutoryOptions: [],
      employee_salary_statutory_employee_contribution: '',
      employee_salary_statutory_employer_contribution: '',
      salary_heads_rows: [],
      company_salary_statutory_rows: [],
      salary_total: [],
      company_salary_head_id: null,
      company_salary_head:"",
      employee_salary_head_id: null,
      amount: "",
      ctc: "",
      gross: "",
      fixedHeads: [],
      otType: "",
      fixedRate: "",
      updateSalary: false,
      loadingUpdate: false,
      decodedData: [],
      applicable_ot_type: "",
      errors:{},
      effective_date:"",
      log_rows: [],
      employee_id:'',
      viewSalaryLogs:false,
      
    };
  }
  

  componentDidMount() {
    this.GetSalaryHeadList();
    this.GetSalaryStatutoryList();
    this.GetInfo();
    this.GetSalaryHeadList();
    this.setState({ loadingList: true }, (prevState) => {
      // this.GetLogList();
    });
  }
  

  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  validateForm = () => {
    const errors = {};

    if (!this.state.effective_date) {
        errors.effective_date = 'Salary Effective Date is required';
    }
  }
  GetSalaryHeadList = async () => {
    const { apiURL, apiHeaderJSON } = this.context
    const headers = apiHeaderJSON
    axios
      .get(`${apiURL}Payrolls/GetSalaryHeadList`, {
        params: {
          limit: 1000,
          page: 1
        },
        headers
      })
      .then(response => {
        let data = response.data
        console.log(response?.data)
        if (response.data.success === true) {
          let headRows = data?.result?.data.filter(val => {
            if (val?.salary_head_type === 'Fixed Component') {
              return {
                value: val?.company_salary_head_id,
                label: val?.company_salary_head
              }
            }
          })
          headRows = headRows?.map(val => {
            return {
              value: val?.company_salary_head_id,
              label: val?.company_salary_head
            }
          })
          this.setState({ fixedHeads: headRows })
        } else {
        }
      })
      .catch(function (error) {
        console.log('error', error)
      })
  }

//   GetLogList = (id) => {
//     const { apiURL, apiHeaderJSON } = this.context;
//     const headers = apiHeaderJSON;

//     axios
//       .get(`${apiURL}Employees/GetSalaryRevision?employee_id=${id}`, { headers })
//       .then((response) => {
//         var data = response.data;
//         console.log("GetLogList", data);

//         if (response.data.success === true) {
//           this.setState(
//             {
//               logs_details_rows: data,
//               loadingList: false,
//             },
//             () => {
//               console.log(
//                 "Latest Log Date:",
//                 this.state.logs_details_rows?.data[0]?.effective_date
//               );
//             }
//           );
//         } else {
//           this.setState({ loadingList: false });
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching logs:", error);
//         this.setState({ loadingList: false });
//       });
// };

// GetLogList = (row) => {
//   const { apiURL, apiHeaderJSON } = this.context;
//   const headers = apiHeaderJSON;
  
//   if (!row?.employee_id) {
//     Swal.fire({ 
//       title: `<strong>Error</strong>`, 
//       text: "Employee ID is missing!", 
//       icon: "error", 
//       showConfirmButton: true,
//       allowOutsideClick: false, 
//     });
//     return;
//   }

//   axios
//     .get(`${apiURL}Employees/GetSalaryRevisionLogs`, {
//       params: {
//         limit: this.state.limit,
//         page: this.state.page,
//         keyword: this.state.keyword,
//         employee_id: row.employee_id,  // Correctly passing employee_id
//       },
//       headers,
//     })
//     .then((response) => {
//       console.log("GetLogList Response:", response.data);
      
//       if (response.data.success === true) {
//         this.setState({
//           loadingLogs: false,
//           logs_details_rows: Array.isArray(response.data.data) && response.data.data.length > 0 ? response.data.data : [],
//           viewSalaryRevisionLog: row.company_salary_head, 
//         });
//       } else {
//         Swal.fire({ 
//           title: `<strong>Failed</strong>`, 
//           text: "Oops! Something went wrong.", 
//           icon: "error", 
//           showConfirmButton: true,
//           allowOutsideClick: false, 
//         });
//         this.setState({ loadingLogs: false });
//       }
//     })
//     .catch((error) => {
//       console.error("Error fetching logs:", error);
//       Swal.fire({ 
//         title: `<strong>Failed</strong>`, 
//         text: "Oops! Something went wrong.", 
//         icon: "error", 
//         showConfirmButton: true,
//         allowOutsideClick: false, 
//       });
//       this.setState({ loadingLogs: false });
//     })
//     .finally(() => {
//       this.setState({ loadingList: false, loadingLogs: false });
//     });
// };


GetLogList = () => {
  const { apiURL, apiHeaderJSON } = this.context;
  const headers = apiHeaderJSON;
  axios
    .get(`${apiURL}Employees/GetSalaryRevisionLogs`, {
      params: {
          employee_id: this.props.params.employee_id,
          date: currentDateAndTime(),
      },
      headers,
    })
    .then((response) => {
      var data = response.data;
      console.log("response.data====>",response.data)
      this.setState({ log_rows: [] });
      if (response.data.success === true) {
        this.setState({
          log_rows: data.data,
          viewSalaryLogs:true,
          loadingLogs: false,
        });
      } else {
        this.setState({ log_rows:[], loadingLogs: false });
      }
    })
    .catch((error)=>{
      console.error("Error GetSalaryRevisionLogs: ",error);
      this.setState({ loadingLogs: false });
    });
};
  GetSalaryStatutoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetSalaryStatutoryList`, { headers }).then((response) => {
      var data = response.data;
      if (response.data.success === true) {
        this.setState({
          company_salary_statutory_rows: data.data.map((row) => ({
            value: row.company_salary_statutory_id,
            label: row.company_salary_statutory_title,
            company_salary_statutory_employee_contribution: row.company_salary_statutory_employee_contribution,
            company_salary_statutory_employer_contribution: row.company_salary_statutory_employer_contribution,
          }))
        });
      }
    });
  }

  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetEmployeeInfo?employee_id=${this.props.params.employee_id}`, { headers }).then((response) => {
      const { data, success,salary_Heads, ctc} = response.data;
      // console.log("response.data===>",response.data)
      if (success === true) {
        this.setState(
          {
            salaryRows:salary_Heads,
            allowances: response.data.salary_Heads,
            salary_statutory: response.data.salary_statutory,
            salary_total: response.data.salary_total,
            // applicable_ot_type: response.data.applicable_ot_type ?? null,
            // applicable_ot_type: response.data.applicable_ot_type,
            applicable_ot_type: data[0].applicable_ot_type, 
            // effective_date: salary_Heads[0].effective_date,
         
            gross: data[0].gross,
            ctc: ctc,
          }
        )
      }
    });
  }
  
  handleDelete = (company_salary_head_id) => {

    // const { apiURL, apiHeaderJSON } = this.context;
    // const headers = apiHeaderJSON;
    // Swal.fire(
    //   {
    //     title: 'Are you sure?',
    //     text: "You won't be able to revert this!",
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'Yes, delete it!'
    //   }
    // ).then((result) => {
    //   if (result.isConfirmed) {
       
    //       const api = `${apiURL}Employees/DeleteSalaryHead`;
        
    //     const formData = {
    //       employee_id: this.props.params.employee_id,
    //       company_salary_head_id: company_salary_head_id,
    //     };
    //     axios.post(api, formData, { headers })
    //       .then((response) => {
    //         Swal.fire({
    //           title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
    //           text: response.data.message,
    //           icon: response.data.success === true ? 'success' : 'error',
    //           showConfirmButton: true,
    //           allowOutsideClick:false
    //         });
    //         this.setState({ status: false });
    //         if (response.data.success === true) {
    //           this.setState({ loadingList: true }, (prevState) => {
    //             this.GetInfo();
    //           })
    //         }
    //       })
    //       .catch((error)=>{
    //         console.log("ERROR:",error);
    //         Swal.fire({
    //           title: `<strong>Failed</strong>`,
    //           text: "Opps...! Something went wrong!",
    //           icon: 'error',
    //           showConfirmButton: true,
    //           allowOutsideClick:false
    //         })
    //       });
    //   }
    // });

    const temp = this.state.salaryRows.filter((val)=> val?.company_salary_head_id != company_salary_head_id)
    this.setState({ salaryRows: temp });

  }

  GetSalaryHeadsInfo = (employee_salary_head_id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    this.setState({ employee_salary_head_id: employee_salary_head_id });
    axios.get(`${apiURL}Employees/GetSalaryHeadsInfo`, { params: { employee_id: this.props.params.employee_id, employee_salary_head_id: employee_salary_head_id }, headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true) {
        this.setState(
          {
            amount: data[0].amount,
            effective_date: data[0].effective_date,
            company_salary_head_id: data[0].company_salary_head_id,
          }
        )
      }
    });
  }

  GetSalaryStatutoryInfo = (idx) => {
    // const { apiURL, apiHeaderJSON } = this.context;
    // const headers = apiHeaderJSON;
    // this.setState({ employee_salary_statutory_id: employee_salary_statutory_id });
    // axios.get(`${apiURL}Employees/GetSalaryStatutoryInfo`, { params: { employee_id: this.props.params.employee_id, employee_salary_statutory_id: employee_salary_statutory_id }, headers }).then((response) => {
    //   const { data, success } = response.data;
    //   if (success === true) {
    //     this.setState(
    //       {
    //         company_salary_statutory_id: data[0].company_salary_statutory_id,
    //         employee_salary_statutory_employee_contribution: data[0].employee_salary_statutory_employee_contribution,
    //         employee_salary_statutory_employer_contribution: data[0].employee_salary_statutory_employer_contribution,
    //       }
    //     )
    //   }
    // });
    this.setState({
      company_salary_head_id:this.state.salaryRows[idx]?.company_salary_head_id,
      // company_salary_head:this.state.salaryRows[idx]?.company_salary,
      amount:this.state.salaryRows[idx]?.company_salary_head_value,
      updateSalary:`${idx}`
    })
  }
  handleUpdate= () => {
    const temp = [...this.state.salaryRows]; // Create a shallow copy of the array

    const index = parseInt(this.state.updateSalary); // Index of the element to update
    if (index >= 0 && index < temp.length) {
        // Update the specific element at the given index
        temp[index] = {
            ...temp[index],
            company_salary_head_value: this.state.amount,

            
        };
    }

    // Debugging: Log the updated value for verification
    console.log('Updated element:', temp[index]);

    // Update the state with the modified array
    this.setState({ salaryRows: temp, updateSalary: false,company_salary_head_id:"",
      amount:"", }, () =>
        console.log('Updated salaryRows:', this.state.salaryRows)
    );
};
handleAdd = () => {
  const { selectedSalaryType, amount,company_salary_head, allowances, salaryRows, company_salary_head_id } =
    this.state

  // Validate if company_salary_head_id or amount is missing
  console.log("company_salary_head_id, amount ===>",company_salary_head_id, amount, );
  console.log("company_salary_head==>",company_salary_head)
  if (!company_salary_head_id || !amount ) {
    Swal.fire({
      icon: 'warning',
      title: '<strong>Oops..</strong>',
      text: `Please select a ${!company_salary_head_id && !amount?"salary type and enter an amount":!company_salary_head_id? "salary type":  !amount? "enter an amount":""}!`,
      showConfirmButton: true,
      allowOutsideClick: false
    }).then(() => {
      // Set state after "OK" button is clicked
      
      this.setState({ amount:false });
      this.setState({ company_salary_head_id:false });
      this.setState({ company_salary_head: false });
    });
    console.log("company_salary_head==>",company_salary_head)
    return
  }

  // Check for duplicate company_salary_head_id
  const isDuplicate = salaryRows.some(
    allowance => allowance.company_salary_head_id === company_salary_head_id
  )

  if (isDuplicate) {
    Swal.fire({
      icon: 'error',
      title: '<strong>Error</strong>',
      text: 'This salary head has already been added!',
      showConfirmButton: true,
      allowOutsideClick: false
    }).then(() => {
      // Set state after "OK" button is clicked
      this.setState({ amount:false, company_salary_head: false,company_salary_head_id: false });
    });
    return
  }

  // Proceed to add the new allowance
  const newAllowance = {
    company_salary_head_id: company_salary_head_id,
    company_salary_head: company_salary_head,
    company_salary_head_value: amount
  }
  
  const temp=[...salaryRows];
  temp.push(newAllowance)
  // console.log("temp ===>",temp);
  this.setState(
    {
      salaryRows: temp,
      company_salary_head_id:false,
      company_salary_head: false,
      selectedSalaryType: null,
      amount: '',
    },
    () => {
      // console.log("salaryRows ===>",salaryRows);
      this.handleCTCStatutory()
    }
  );
}

// handleAdd = () => {
//   const { selectedSalaryType, amount, company_salary_head, allowances, salaryRows, company_salary_head_id } = this.state;

//   console.log("company_salary_head_id, amount ===>", company_salary_head_id, amount);

//   // Validate if company_salary_head_id or amount is missing
//   if (!company_salary_head_id || !amount) {
//     Swal.fire({
//       icon: 'warning',
//       title: '<strong>Oops..</strong>',
//       text: `Please select a ${!company_salary_head_id && !amount ? "salary type and enter an amount" : !company_salary_head_id ? "salary type" : !amount ? "enter an amount" : ""}!`,
//       showConfirmButton: true,
//       allowOutsideClick: false
//     });
//     return;
//   }

//   // Check for duplicate company_salary_head_id
//   const isDuplicate = salaryRows.some(
//     allowance => allowance.company_salary_head_id === company_salary_head_id
//   );

//   if (isDuplicate) {
//     Swal.fire({
//       icon: 'error',
//       title: '<strong>Error</strong>',
//       text: 'This salary head has already been added!',
//       showConfirmButton: true,
//       allowOutsideClick: false
//     });
//     return;
//   }

//   // Proceed to add the new allowance
//   const newAllowance = {
//     company_salary_head_id: company_salary_head_id,
//     company_salary_head_value: parseFloat(amount).toFixed(2)
//   };

//   this.setState(
//     {
//       salaryRows: [...salaryRows, newAllowance], // Keep old values + add new entry
//       selectedSalaryType: null, // Reset dropdown only
//       // amount and company_salary_head_id are NOT reset
//     },
//     () => {
//       this.handleCTCStatutory(); // Call next function if required
//     }
//   );
// };

handleCTCStatutory=()=>{
  const {  salaryRows } = this.state
  const totalCtc = salaryRows?.length>0 && salaryRows
  ?.reduce(
    (total, allowance) =>
      total +
      parseFloat(
        allowance.company_salary_head_value
      ),
    0
  );
  this.setState({
    ctc:totalCtc
  })
}
  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clear the specific error related to the changed input
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };


  handleAddAndUpdateHeads = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    // if (!this.state.amount) {
    //   // use swal
    //   Swal.fire('Please enter amount', 'It is required!', 'warning');
    //   return false;
    // }
    var formData = {
      employee_id: this.props.params.employee_id,
      salaryData:this.state.salaryRows,
      applicable_ot_type: this.state.applicable_ot_type,
      effective_date: this.state.effective_date,
      date: currentDateAndTime(),
    };
    const api = `${apiURL}Employees/AddSalaryHeads`;
this.setState({
  loadingUpdate:true
})
    axios.post(api, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        console.log("response data:", response.data);
        if (success === true) {
          Swal.close();
          this.setState({
            employee_salary_head_id: null,
            allowances: [],
            salary_statutory: [],
            statutoryOptions: [],
            employee_salary_statutory_employee_contribution: '',
            employee_salary_statutory_employer_contribution: '',
            salary_heads_rows: [],
            company_salary_statutory_rows: [],
            company_salary_head_id: null,
            applicable_ot_type: null,
            amount: "",
            
            // company_salary_head: '',
            // effective_date:'',
            loadingUpdate:false,
            
          });

          this.setState({ loadingList: true }, (prevState) => {
            this.GetSalaryHeadList();
            this.GetSalaryStatutoryList();
            this.GetInfo();
          });
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton: true,
      allowOutsideClick: false
          });
        } else {
          // Swal.close();
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
            showConfirmButton: true,
      allowOutsideClick: false
          });
          this.setState({ loadingList: true, loadingUpdate:false }, (prevState) => {
            this.GetSalaryHeadList();
            this.GetSalaryStatutoryList();
          });
        }
      }).catch((error)=>{
        this.setState({ loadingList: true, loadingUpdate:false });
        console.log(" ERROR:",error);
        Swal.fire({
          title: `<strong>Failed</strong>`,
          text: "Opps...! Something went wrong!",
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        })
      });
  };

  handleAddAndUpdateStatutory = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    if (!this.state.employee_salary_statutory_employer_contribution || !this.state.employee_salary_statutory_employee_contribution) {
      Swal.fire('Please Enter Employee And Employer Contributions', 'It is required!', 'warning');
      return false;
    }
    var formData = {
      employee_salary_statutory_employer_contribution: this.state.employee_salary_statutory_employer_contribution,
      employee_salary_statutory_employee_contribution: this.state.employee_salary_statutory_employee_contribution,
      company_salary_statutory_id: this.state.company_salary_statutory_id,
      employee_id: this.props.params.employee_id,
      employee_salary_statutory_id: this.state.employee_salary_statutory_id,
      effective_date: this.state.effective_date
    };

    var api = `${apiURL}Employees/UpdateSalaryStatutory`;

    if (this.state.employee_salary_statutory_id != null) {
      api = `${apiURL}Employees/UpdateSalaryStatutory`;
    } else {
      api = `${apiURL}Employees/AddSalaryStatutory`;
    }
    axios.post(api, formData, { headers })
      .then((response) => {
        const { success } = response.data;
        if (success === true) {
          Swal.close();
          this.setState({
            employee_salary_statutory_id: null,
            allowances: [],
            salary_statutory: [],
            statutoryOptions: [],
            employee_salary_statutory_employee_contribution: '',
            employee_salary_statutory_employer_contribution: '',
            salary_heads_rows: [],
            applicable_ot_type: [],
            company_salary_statutory_rows: [],
            company_salary_statutory_id: null,
            amount: "",
            
          });

          this.setState({ loadingList: true }, (prevState) => {
            this.GetSalaryHeadList();
            this.GetSalaryStatutoryList();
            this.GetInfo();
            // this.GetLogList();
          });
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
          });
        } else {
          Swal.close();
          Swal.fire({
            title: `<strong>${response.data.success === true ? "Success" : "Failed"
              }</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? "success" : "error",
          });
          this.setState({ loadingList: true }, (prevState) => {
            this.GetSalaryHeadList();
            this.GetSalaryStatutoryList();
          });
        }
      });
  };

  handleAmountChange = (e) => {
    this.setState({ amount: e.target.value });
  };

  // company_salary_statutory //
  handleStatutoryTypeChange = (selectedOption) => {
    this.setState({
      company_salary_statutory_id: selectedOption.value,
      // statutoryType: selectedOption,
      employee_salary_statutory_employee_contribution: selectedOption.company_salary_statutory_employer_contribution,
      employee_salary_statutory_employer_contribution: selectedOption.company_salary_statutory_employee_contribution
    });

  };

  handleEmployeeContributionChange = (e) => {
    this.setState({ employee_salary_statutory_employee_contribution: e.target.value });
  };

  handleEmployerContributionChange = (e) => {
    this.setState({ employee_salary_statutory_employer_contribution: e.target.value });
  };

  handleFixedRateChange = (event) => {
    this.setState({ fixedRate: event.target.value });
  };
  // Handler function for Select component change
  // handleSelectChange = (name, selectedOption) => {
  //   // Clear the specific error related to the changed input
  //   this.setState((prevState) => ({
  //     [name]: selectedOption.value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: '',
  //     },
  //   }));
  //   console.log(" Selected: ", selectedOption);
    
  // };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption ? selectedOption.value : null, 
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
    console.log("Selected: ", selectedOption);
  };
  

  handleAddNew = () => {
    this.setState({
      employee_salary_head_id: null,
      employee_salary_statutory_id: null,
      employee_salary_statutory_employee_contribution: "",
      employee_salary_statutory_employer_contribution: "",
      amount: "",

      company_salary_head_id: null,
      applicable_ot_type: null,
      company_salary_statutory_id: null,
     
    });
  }
  handleTypeChange = (type,selectedOption) => {
    // console.log("selectedOption",selectedOption);

    if(type==="salaryHead"){
      this.setState({
        // salary_detail_id: selectedOption?.salary_detail_id,
        company_salary_head_id: selectedOption.value,
        // otType: selectedOption.ot_type,
        // fixedRate: selectedOption.fixedRate,
        company_salary_head: selectedOption?.label,
        // amount: selectedOption.amount,
      });
    }
    
  };

  render() {
    
    const { amount, allowances,  otType,fixedRate,errors, row} = this.state;
    return (
      <div>
        <div className="row g-3">
          <div>
            <h5>
              Salary Details
            </h5>
      <div className='row'>
        <div className="col-md-3" style={{ zIndex: 5 }}> 
        <label htmlFor="otType" className="form-label">
          Edit OT Type:
        </label>
        {/* <Select
          options={otTypes}
          onChange={(selectedOption)=> this.handleSelectChange("applicable_ot_type",selectedOption)}
          value={this.state.applicable_ot_type ? otTypes.find(option => option.value === this.state.applicable_ot_type) : null}
        /> */}
        <Select
          options={otTypes}
          onChange={(selectedOption) => this.handleSelectChange("applicable_ot_type", selectedOption)}
          value={otTypes.find(option => option.value === this.state.applicable_ot_type) || null}
        />

                      
        {/* </div> */}
        {/* </div> */}
        </div>
       
        {/* <div className="col-md-3">
        {this.state.applicable_ot_type === "0" && (
          <div className="ms-3">
            <label htmlFor="fixedRate" className="form-label">Enter Fixed Rate Amount:</label>
            <input
              type="number"
              id="fixedRate"
              name="fixedRate"
              className="form-control"
              value={this.state.fixedRate}
              onChange={this.handleFixedRateChange}
            />
          </div>
        )}
        </div> */}
                         <div className="col-md-3 mb-3">
                            <label htmlFor="effective_date" className="form-label">Salary Effective Date:
                            <span
                               style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span>
                            </label>
                            <input
                              type="date"
                              id="effective_date"
                              name="effective_date"
                              value={this.state.effective_date}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.effective_date ? 'is-invalid' : ''}`}
                              placeholder="Select the effective date"
                            />
                            {errors.effective_date && <div className="invalid-feedback">{errors.effective_date}</div>}
                          </div>
                          {/* <button
                              type="button"
                              className="btn btn-sm btn-info"
                              onClick={() => {
                                if (!this.state.loadingLogs) {
                                  this.setState(
                                    {
                                      loadingLogs: `${row?.employee_id}`,
                                    },
                                    () => this.GetLogList(row)
                                  );
                                }
                              }}
                            >
                              Logs                              
                          </button> */}
                          <div className="col-md-3 mb-3">
                            <label className="form-label">Salary Revision Log:
                           
                            </label>
                            <div className="d-flex">
                            {this.state.decodedData?.includes(5) && (
                                //  <IconButton 
                                //  loading={this.state.loadingLogs}
                                //  onClick={() => {
                                //    if (!this.state.loadingLogs) {
                                //      this.setState(
                                //        {
                                //          loadingLogs: true,
                                //        },
                                //        () => this.GetLogList()
                                //      );
                                //    }
                                //  }} type='success' icon='ri-file-info-line' tooltipName='Salary Revision Logs' tooltipPosition='bottom' />
                                 <SubmitButton onClick={(e)=>{ 
                                  this.setState({
                                           loadingLogs: true,
                                         },
                                         () => this.GetLogList()
                                       )}}
                                  loading={this.state.loadingLogs}
                                  loadingMessage='Loading' buttonName={'Salary Logs'} icon={'ri-file-info-line'} 
                                  type='success' iconSide='left' />
                              )}                           
                            </div>             
                          </div>
                          {/* {this.state.decodedData?.includes(5) &&
                                            (this.state.loadingLogs === row.employee_id ? (
                                                          <button className="btn btn-sm btn-info btn-load">
                                                            <span className="d-flex align-items-center">
                                                              <span
                                                                className="spinner-border flex-shrink-0"
                                                                role="status"
                                                                style={{
                                                                  width: "0.8rem",
                                                                  height: "0.8rem",
                                                                  borderWidth: "2px",
                                                                }}
                                                              >
                                                                <span className="visually-hidden">Loading...</span>
                                                              </span>
                                                            </span>
                                                          </button>
                                                        ) : (
                                                          (this.state.decodedData?.includes(5) && 
                                                          <button
                                                            type="button"
                                                            className="btn btn-sm btn-info"
                                                            onClick={() => {
                                                              if (!this.state.loadingLogs) {
                                                                this.setState(
                                                                  {
                                                                    loadingLogs: `${row?.employee_id}`,
                                                                  },
                                                                  () => this.GetLogList(row)
                                                                );
                                                              }
                                                            }}
                                                          >
                                                            Logs
                                                          </button>)

                                            ))
                                          } */}

                          {/* {this.state.updateSalary && (
           <div className="col-md-3 mb-3">
                            <label htmlFor="effective_date" className="form-label">Salary Effective Date:
                            <span
                               style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>
                              *
                            </span>
                            </label>
                            <input
                              type="date"
                              id="effective_date"
                              name="effective_date"
                              value={this.state.effective_date}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.effective_date ? 'is-invalid' : ''}`}
                              placeholder="Select the effective date"
                            />
                            {errors.effective_date && <div className="invalid-feedback">{errors.effective_date}</div>}
                          </div>     )}           */}
          </div>
          { this.state.viewSalaryLogs && (
            <div className="modal show" 
            style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}  >
            <div className="modal-dialog modal-xl"
                style={{ width: "90%" }}>
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="rmModalLabel">Salary Revision Logs</h5>
                    <button type="button" className="btn-close" onClick={()=> this.setState({ viewSalaryLogs:false, log_rows : [] })} aria-label="Close" />
                </div>
                <div className="modal-body">
                  <div className="container mt-2">
                  <div style={{ "maxHeight": "30rem", "overflowY": "auto", "overflowX": "auto" }}>
                    <table className="table table-bordered table-stripped">
                      <thead style={{ width:"100%"}} className="table-light sticky-top z-1">
                        <tr>
                          {/* <th scope="col" width="10%">Id</th> */}
                          <th style={{ width:"5%"}}>Sr.No.</th>
                          <th className='noWrap' style={{ width:"10%"}}>Revised Date</th>
                          <th className='noWrap' style={{ width:"10%"}}>Effective Date</th>
                          <th className='noWrap' style={{ width:"10%"}}>Revised By</th>
                          <th style={{ width:"80%"}}>Salary Heads</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.log_rows?.map((row,idx) => (
                          <tr key={idx} >
                            <td>{idx+1}</td>
                            <td>{row?.revision_datetime ? formatDate(row?.revision_datetime) : "--"}</td>
                            <td>{row?.effective_date ? formatDate(row?.effective_date) : "--"}</td>
                            <td>{row?.company_user_name|| "--"}</td>
                            <td>
                              <div className=' d-flex align-items-center gap-2 flex-wrap'>
                                {Array.isArray(row?.salary_details) && row?.salary_details?.map((val)=>{
                                  return (
                                    <div className=' border border-info py-1 px-2 rounded-3'>
                                      <h6 className={`mb-0 noWrap text-${ val?.salary_status=="1" ? 'success' : val?.salary_status=="2" ? "info" : val?.salary_status=="3" ? "danger" : "dark-50"}`}>{val?.company_salary_head}</h6>
                                      <h6 className={`mb-0 text-${ val?.salary_status=="1" ? 'success' : val?.salary_status=="2" ? "info" : val?.salary_status=="3" ? "danger" : "dark-50"}`}>{val?.company_salary_head_value}</h6>
                                    </div>
                                  )
                                })}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  </div>
                </div>
                </div>
            </div>
            </div>
          )}
          </div>
          {this.state.updateSalary && (
            <div
            id=""
            className=" w-100 m-auto rounded-2"
            tabIndex={-1}
            style={{ display: 'block', }}
            aria-labelledby="myModalLabel"
            aria-hidden="true"
            >
                <div className=" bg-light m-auto mt-3  py-1 px-2" style={{ width: '100%' }}  >
                    <div className="modal-content">
                        <div className="modal-header mb-3">
                            <h5 className="modal-title" id="myModalLabel">
                            Salary Update
                            </h5>
                            <button
                            onClick={() => {
                                this.setState({ 
                                  company_salary_head_id:"",
                                  amount:"",
                                  updateSalary:false,
                                });
                            }}
                            className="btn-close"
                            aria-label="Close"
                            ></button>
                        </div>
                        
                        <div className="modal-body">
                            <div className='row pb-3'>
                              <div className=" d-flex justify-content-between align-items-center">
                                
                                <div className="w-25">
                                  <Select
                                    options={this.state.fixedHeads}
                                    onChange={(selectedOption)=> this.handleTypeChange("salaryHead",selectedOption)}
                                    isDisabled
                                    value={this.state.company_salary_head_id ? this.state.fixedHeads.find(option => option.value === this.state.company_salary_head_id) : null}
                                  />
                                </div>
                                <div className="">
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Amount"
                                    value={amount}
                                    onChange={this.handleAmountChange}
                                    id="cleave-numeral"
                                  />
                                </div>
                              
                                <div className="">
                                {!this.state.loadingUpdate?
                                  <button
                                      type="submit"
                                      className="btn btn-success btn-label ms-auto waves-effect waves-light"
                                      onClick={()=> {this.handleUpdate()}} 
                                  >
                                      <i className="bx bx-save label-icon align-middle fs-16 ms-2" />
                                      Update
                                  </button>:
                                  <button className="btn btn-success btn-load">
                                    <span className="d-flex align-items-center">
                                        <span className="spinner-border flex-shrink-0" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </span>
                                        <span className="flex-grow-1 ms-2">
                                            Saving...
                                        </span>
                                    </span>
                                  </button>}
                                  {/* <button
                                  onClick={() => {
                                      this.setState({
                                        company_salary_head_id:"",
                                        amount:"",
                                        updateSalary:false,
                                      });
                                  }}
                                  className="btn btn-light"
                                  >
                                  Close
                                  </button> */}
                                </div>
                                {/* <div className="">
                                  {this.state.employee_salary_head_id != null ? (
                                    <button
                                      type="button"
                                      className="btn btn-light btn-label waves-effect right waves-light"
                                      onClick={this.handleAddNew}
                                    >
                                      <i className=" ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                      New
                                    </button>
                                  ) : <>
                                  </>
                                  }
                                </div> */}
                              </div>
                            </div>
                        </div>


                        {/* <div className="modal-footer">
                            {!this.state.loadingUpdate?
                            <button
                                type="submit"
                                className="btn btn-danger btn-label ms-auto waves-effect waves-light"
                                onClick={()=> {this.handleCancelEmail(this.state.resendEmail)}} 
                            >
                                <i className="ri-mail-close-line label-icon align-middle fs-16 me-2" />
                                Update
                            </button>:
                            <button className="btn btn-success btn-load">
                              <span className="d-flex align-items-center">
                                  <span className="spinner-border flex-shrink-0" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                  </span>
                                  <span className="flex-grow-1 ms-2">
                                      Saving...
                                  </span>
                              </span>
                            </button>}
                            
                            <button
                            onClick={() => {
                                this.setState({
                                  company_salary_head_id:"",
                                  amount:"",
                                  updateSalary:false,
                                });
                            }}
                            className="btn btn-light"
                            >
                            Close
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
            )}
          {!this.state.updateSalary?
          <div className="py-3 mb-3 d-flex justify-content-between align-items-center">
              <div className="w-25" style={{ zIndex: 4 }}>
                <Select
                  options={this.state.fixedHeads}
                  onChange={(selectedOption)=> this.handleTypeChange("salaryHead",selectedOption)}
                  value={this.state.company_salary_head_id ? this.state.fixedHeads.find(option => option.value === this.state.company_salary_head_id) : null}
                />
              </div>
              <div className="">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={this.handleAmountChange}
                  id="cleave-numeral"
                />
              </div>
            
              <div className="">
                
                  <button
                    type="button"
                    className="btn btn-success btn-label waves-effect right waves-light"
                    onClick={this.handleAdd}
                  >
                    <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" />
                    Add
                  </button>
                
              </div>
              {/* <div className="">
                {this.state.employee_salary_head_id != null ? (
                  <button
                    type="button"
                    className="btn btn-light btn-label waves-effect right waves-light"
                    onClick={this.handleAddNew}
                  >
                    <i className=" ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                    New
                  </button>
                ) : <>
                </>
                }
              </div> */}
            </div>:null}
          <div style={{ "maxHeight": "30rem", "overflowY": "auto", "overflowX": "auto" }}>
            <table className="table table-bordered table-stripped">
              <thead style={{ width:"100%"}} className="table-light sticky-top z-1">
                <tr>
                  {/* <th scope="col" width="10%">Id</th> */}
                  <th style={{ width:"10%"}}>Sr.No.</th>
                  <th style={{ width:"50%"}}>Salary Head</th>
                  {/* <th>Employee</th>
                  <th>Employeer</th> */}
                  <th style={{ width:"30%"}}>Amount</th>
                  <th style={{ width:"10%"}} className=' text-center'>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.salaryRows?.map((row,idx) => (
                  <tr key={row?.company_salary_head_id} >
                    <td>{idx+1}</td>
                    <td>{row?.company_salary_head}
                      {/* {this.state.salary_total.map((row) => (

                        <small className="text-muted text-center">{row.formula}</small>
                      ))} */}
                    </td>
                    <td>{row?.company_salary_head_value}</td>
                    {/* <td>{row?.employee_salary_statutory_employee_contribution}</td>
                    <td>{row?.employee_salary_statutory_employer_contribution}</td> */}
                    {/* {this.state.salary_total.map((row) => (
                      <td>
                        {row.total}
                      </td>
                    ))} */}

                    <td>
                      <div className='d-flex justify-content-center'>
                        <div className='mx-3'>
                          <button type="button" className="btn btn-link btn-icon btn btn-sm btn-outline-info" onClick={() => { this.GetSalaryStatutoryInfo(idx) }}>
                            <i className="ri-edit-box-line" />
                          </button>
                        </div>
                        <div>
                          <button type="button" className="btn btn-danger btn-icon btn btn-sm btn-outline-danger" onClick={() => { this.handleDelete(row?.company_salary_head_id, 0) }}>
                            <i className="ri-delete-bin-line" />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {/* <tfoot className="table-light sticky-bottom">
                <tr>
                <th scope="rowgroup" >
                </th>
                <th scope="rowgroup" >
                  CTC
                </th>
                <th scope="rowgroup" >
                  {this.state.ctc}
                </th> 
                <th scope="rowgroup" >
                  
                </th>
                  <th scope="rowgroup" colSpan="2"></th> 
                </tr>
              </tfoot> */}
            </table>
          </div>
          <div style={{ width:"fit-content"}} className="">
          {!this.state.loadingUpdate?
            <button
                type="submit"
                className="btn btn-success btn-label ms-auto waves-effect waves-light"
                onClick={()=> {this.handleAddAndUpdateHeads()}} 
            >
                <i className="bx bx-save label-icon align-middle fs-16 ms-2" />
                Save
            </button>:
            <button className="btn btn-success btn-load">
              <span className="d-flex align-items-center">
                  <span className="spinner-border flex-shrink-0" role="status">
                      <span className="visually-hidden">Loading...</span>
                  </span>
                  <span className="flex-grow-1 ms-2">
                      Saving...
                  </span>
              </span>
            </button>}
          </div>
          
        </div>

      </div>
    );
  }
}

export default withRouter(LevelDetails);
